// ======================================================================
// File: TransportHeaderBanner.jsx
// Module: PPE → Transport
// Purpose:
//   Module header banner aligned with PPE UI standard
//   (Same pattern as Indent Management header)
// ======================================================================

import React from "react";


// ======================================================================
// COMPONENT
// ======================================================================

export default function TransportHeaderBanner({ onCreate }) {
  return (
    <div
      className="d-flex justify-content-between align-items-center mb-3 p-3"
      style={{
        background: "linear-gradient(90deg, #1aa39a, #6bd1c7)",
        borderRadius: "8px",
        color: "#fff",
      }}
    >
      {/* --------------------------------------------------------------
          LEFT CONTENT
      -------------------------------------------------------------- */}
      <div>
        <h5 className="mb-1 fw-bold">
          Transport Management
        </h5>

        <small>
          Logistics movement & delivery execution
        </small>
      </div>

      {/* --------------------------------------------------------------
          ACTION BUTTON
      -------------------------------------------------------------- */}
      <button
        className="btn btn-light fw-semibold"
        onClick={onCreate}
      >
        + Create Transport
      </button>
    </div>
  );
}
